<template>
    <div class="grouppurchasedetail">
       <van-nav-bar
                v-if="$route.query.showBack"
                :style="{'backgroundColor':'#E8432A'}"
                title="拼团详情"
                left-arrow
                @click-left="onClickLeft"
        />
        <div class="grouppurchasedetail-content" v-if="!isLoading">
            <div class="good-detail-box">
                <img class="good-bg" src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/goods/ptxq-bg.png"/>
                <div class="good-card">
                    <div class="left-img">
                        <img :src="groupDetail.picUrl"/>
                    </div>
                    <div class="right-detail">
                        <div class="good-title">
                            <b>拼团</b>
                            <span>{{groupDetail.goodsName}}</span>
                        </div>
                        <div class="good-price">
                            ￥{{groupDetail.goodsGroupPrice}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="group-box">
                <div class="just-text" v-if="groupDetail.status==0&&groupDetail.totalNum-groupDetail.curNum>0"><span>还差{{groupDetail.totalNum-groupDetail.curNum}}人，</span>可拼团成功</div>
                <div class="just-text" v-else-if="groupDetail.status==0&&groupDetail.totalNum-groupDetail.curNum==0">拼团支付中</div>
                <div class="just-text" v-else>拼团已满</div>
                <div class="timer-box" v-if="groupDetail.status==0">
                    <span class="text mr-10">距离拼团结束还剩</span>
                    <span class="time">{{days}}</span>
                    <span class="text">天</span>
                    <span class="time">{{hours}}</span>
                    <span class="text">时</span>
                    <span class="time">{{minutes}}</span>
                    <span class="text">分</span>
                    <span class="time">{{seconds}}</span>
                    <span class="text">秒</span>
                </div>
                <div class="members-box">
                    <div class="member-img" v-for="item in groupDetail.memberList" :key="item.id">
                        <img :src="item.headImage?item.headImage:'https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/goods/mr-img.png'"/>
                    </div>
                    <div class="member-img" v-for="(item2,index2) in defaultImg" :key="index2">
                        <img :src="item2.headImage"/>
                    </div>
                </div>
                <div class="btn-box">
                    <div class="join-btn" v-if="!groupDetail.joined&&groupDetail.totalNum-groupDetail.curNum>0" @click="isShowGood=true">参与{{groupDetail.memberList[0].name}}的拼单</div>
                    <div class="invite-btn needCopyBtn" v-else-if="groupDetail.joined&&groupDetail.totalNum-groupDetail.curNum>0" @click="copyShareUrl">邀请好友参团</div>
                    <div class="join-btn" v-else @click="toGood">
                        <template v-if="groupDetail.joined">
                            查看商品
                        </template>
                        <template v-else>
                            去开团
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="loadingBox">
            <div>
                <van-loading type="spinner" color="#1989fa" />
                <div>加载中...</div>
            </div>
        </div>
        <van-popup v-model="isShowGood" position="bottom" round closeable :style="{ height: '11rem' }">
            <div class="pop-content">
                <div class="good-pop">
                    <div class="left-img">
                        <img :src="groupDetail.picUrl"/>
                    </div>
                    <div class="right-detail">
                        <div class="good-title">
                            <b>拼团</b>
                            <span>{{groupDetail.goodsName}}</span>
                        </div>
                        <div class="good-price">
                            ￥{{groupDetail.goodsGroupPrice}}
                        </div>
                    </div>
                </div>
                <div class="group-buy-btn" @click="enroll">立即购买</div>
            </div>
        </van-popup>
        <!-- <van-overlay :show="show">
            <div class="share-tip" @click.stop>
                <img class="tip-img" src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/goods/ydy.png"/>
                <img class="btn-img" @click="show = false" src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/goods/zdl-btn.png"/>
            </div>
        </van-overlay> -->
    </div>
</template>

<script>
import Clipboard from 'clipboard';
import { Toast } from 'vant';
export default {
  name: "grouppurchasedetail-invite",
  data(){
    return{
        isShowGood:false,
        show:false,
        timer:null,
        days:'00',
        hours:'00',
        minutes:'00',
        seconds:'00',
        residue:'',
        counts:'',
        groupId:this.$route.query.id||'',
        groupDetail:{},
        isLoading:true,
        isWechat: this.$publicFn.getUserAgent() === 'wechat',
        defaultImg:[]
    }
  },
  mounted(){
    this.getGroupDetail();
    if (window.history && window.history.pushState) {
            // 往历史记录里面添加一条新的当前页面的url
            history.pushState(null, null, document.URL);
            // 给 popstate 绑定一个方法 监听页面刷新
            window.addEventListener("popstate", this.onClickLeft, false); //false阻止默认事件
    }
  },
  destroyed(){
    clearInterval(this.timer)
    window.removeEventListener("popstate", this.onClickLeft, false)
  },
  methods:{
     //复制分享链接
    copyShareUrl() {
        let txt = `${window.location.protocol}//${window.location.host}/grouppurchasedetailInvite?id=${this.groupDetail.id}`
        console.log('this.copyUrl====',txt)
        let clipboard = new Clipboard('.needCopyBtn', {
            text: function () {
                return txt;
            }
        })
        clipboard.on('success', e => {
            Toast({
                    message: '链接复制成功，快去分享给好友吧～',
                    duration: 1000,
            });
            console.log('复制 成功')
                // 释放内存
            clipboard.destroy();
        })
        clipboard.on('error', e => {
            Toast({
                message: '复制失败',
                duration: 1000,
            });
            clipboard.destroy();
        })
    },
    onClickLeft(){
        this.$router.go(-1)
    },
    toGood(){
        this.$router.push({
            path:'/goodsDetail',
            query:{
                goodsId:this.groupDetail.goodsId,
                goodsKind:this.groupDetail.goodsKinds,
                isToHome:1
            }
        })
    },
    async getGroupDetail(){
        let res = await this.$api.grouppurchase.findOrderGroupByGroupId({groupId:this.groupId});
        this.groupDetail = res.data;
        this.groupDetail.expireTime = this.groupDetail.expireTime?this.groupDetail.expireTime.split('-').join('/'):'';
        this.groupDetail.curTime = this.groupDetail.curTime?this.groupDetail.curTime.split('-').join('/'):'';
        this.isLoading = false;
        this.residue = new Date(this.groupDetail.expireTime).getTime() - new Date(this.groupDetail.curTime).getTime();
        if(this.groupDetail.status==0&&this.residue>0){
            this.counts = parseInt(this.residue / 1000);
            console.log(this.residue,this.seconds)
            this.timer=setInterval(() => {
                this.counts -= 1;
                this.countDown();
                if(this.counts<=0){
                    clearInterval(this.timer)
                }
            }, 1000);
        }
        var num = this.groupDetail.totalNum-this.groupDetail.curNum
        if(num>0){
            for(var i=0; i<num;i++){
                this.defaultImg.push({
                    headImage:'https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/goods/wjr-img.png'
                })
            }
        }
        // if(this.isWechat) {
        //     share.getShare(this,{
        //         imgUrl: this.groupDetail.picUrl,
        //         title: '【拼团】'+this.groupDetail.goodsName,
        //         desc: '点击查看详情',
        //         link:`${window.location.protocol}//${window.location.host}/grouppurchasedetailInvite?id=${this.groupDetail.id}`
        //     })
        // }
    },
    //立即购买
    enroll(){
          if(localStorage.getItem('token')){
                var data = {
                    activityGroupId:this.groupDetail.id,
                    // goodsId:this.goodsId,
                    totalMoney:this.groupDetail.goodsSalePrice,
                    orderSource:2,
                    orderType:this.groupDetail.goodsKinds == 2 ? 4 : this.groupDetail.goodsKinds==1?localStorage.getItem('detailAgentId')?3:1:null,
                    agentId: localStorage.getItem('detailAgentId') || '',
                    distributionUserId:'',
                    shareUserInfo:'',
                    goodsList:[{
                        goodsId:this.groupDetail.goodsId,
                        goodsKinds:this.groupDetail.goodsKinds,
                        num:1,
                        promotionId:'',
                        salePrice:this.groupDetail.goodsGroupPrice
                    }],
                    realPay:this.groupDetail.goodsGroupPrice,
                    platformActivityRuleItemId:this.groupDetail.activityRuleItemId
                }
                this.$api.courseGoodsDetail.ordertoc({data}).then(res=>{
                    if(!res.success) {
                      return
                    }
                    if(res.code==0){
                      if(res.data.placeOrderSuccess && res.data.realPayPrice > 0) {
                        this.$router.push({
                          path: "/gongxin_payment",
                          query: {
                              orderNo: res.data.orderNo,
                              agentId: localStorage.getItem('detailAgentId') || '',
                              goodsKinds:this.groupDetail.goodsKinds
                          }
                        });
                      }else{
                        Toast({
                                message: '您已购买此商品，请勿重复购买',
                                duration: 1000,
                        });
                      }
                    }
                })
          }else{
            this.$router.push({
                path: "/login",
                query: {
                    name: "grouppurchasedetailInvite",
                    ...this.$route.query
                }
            });
              
          }
        // }
    },
    countDown() {
        this.days = parseInt(this.counts / (24 * 60 * 60))
        this.days = this.days < 10 ? "0" + this.days : this.days
        this.hours = parseInt(this.counts / (60 * 60) % 24);
        this.hours = this.hours < 10 ? "0" + this.hours : this.hours
        this.minutes = parseInt(this.counts / 60 % 60);
        this.minutes =  this.minutes < 10 ? "0" +  this.minutes :  this.minutes
        this.seconds = parseInt(this.counts % 60);
        this.seconds = this.seconds < 10 ? "0" + this.seconds : this.seconds
    },
    addZero(d) {
        return parseInt(d) < 10 ? ("0" + d) : (d +'');
    },
  }
}
</script>

<style lang="stylus" scoped>
@import "../asset/css/grouppurchasedetail.styl" 
</style>